import { CategoryRatingData } from '@/domain/entities/dashboard/categoryRatingData'
import { DailySoluition } from '@/domain/entities/dashboard/dailySolution'
import { WeeklyRating } from '@/domain/entities/dashboard/weeklyRating'
import { JudgeRecord } from '@/domain/entities/judge/judgeRecord'
import { Course } from '@/domain/entities/problem/course'
import { CourseSolutionRecord } from '@/domain/entities/problem/courseSolutionRecord'
import { LanguageStatistics } from '@/domain/entities/problem/languageStatistics'
import { User } from '@/domain/entities/user/user'
import { DashboardRepository } from '@/domain/repositories/dashboard/DashboardRepository'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'

export class DashboardUseCase {
  constructor(private repository: DashboardRepository) {}

  async isExistUser(userId: string): Promise<User> {
    try {
      const data = await this.repository.isExistUser(userId)
      return data
    } catch (error) {
      console.error(`Error in DashboardUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }

  async getUserStatistics(userId: string): Promise<LanguageStatistics> {
    try {
      const data = await this.repository.getUserStatistics(userId)
      return data
    } catch (error) {
      console.error(`Error in DashboardUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }

  async getDailySolutionList(userId: string): Promise<DailySoluition[]> {
    try {
      const data = await this.repository.getDailySolutionList(userId)
      return data
    } catch (error) {
      console.error(`Error in DashboardUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }

  async getWeeklyRatingList(userId: string): Promise<WeeklyRating[]> {
    try {
      const data = await this.repository.getWeeklyRatingList(userId)
      return data
    } catch (error) {
      console.error(`Error in DashboardUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }

  async getUserCategoryRatingList(userId: string): Promise<CategoryRatingData> {
    try {
      const data = await this.repository.getUserCategoryRatingList(userId)
      return data
    } catch (error) {
      console.error(`Error in DashboardUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }

  async getUserCategoryRatingListByLanguage(
    userId: string,
    programLanguage: ProgramLanguageType | 'All'
  ): Promise<CategoryRatingData> {
    try {
      const data = await this.repository.getUserCategoryRatingListByLanguage(userId, programLanguage)
      return data
    } catch (error) {
      console.error(`Error in DashboardUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }

  async getUserJudgeRecordList(userId: string): Promise<JudgeRecord[]> {
    try {
      const data = await this.repository.getUserJudgeRecordList(userId)
      return data
    } catch (error) {
      console.error(`Error in DashboardUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }

  async getCourseStatisticsByLanguage(
    courseName: string,
    userId: string,
    programLanguage: ProgramLanguageType
  ): Promise<Course> {
    try {
      const data = await this.repository.getCourseStatisticsByLanguage(courseName, userId, programLanguage)
      return data
    } catch (error) {
      console.error(`Error in DashboardUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }

  async getCourseSolutoinRecordList(userId: string): Promise<CourseSolutionRecord[]> {
    try {
      const data = await this.repository.getCourseSolutoinRecordList(userId)
      return data
    } catch (error) {
      console.error(`Error in DashboardUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
